import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useState } from 'react';
import Modal from 'ud-ui/components/modal';
import { removeBoardTemplateFromCache, useDeleteBoardTemplateMutation } from 'modules/template-editor/store/board-templates-api';
import { useActiveBoardTemplate } from 'modules/template-editor/ui/hooks/use-active-board-template';
import { isDuplicateRequest } from 'shared/errors';
import { useToastApiError } from 'shared/hooks/use-toast-api-error';
import { useAppDispatch } from 'store/hooks';

function useDeleteModal() {
  const { t } = useLingui();
  const dispatch = useAppDispatch();
  const toastApiError = useToastApiError();
  const activeTemplate = useActiveBoardTemplate();
  const [deleteTemplate] = useDeleteBoardTemplateMutation();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Промис — окну подтверждения: его кнопки заперты до ответа. Окно закрывает успех удаления.
  const onSubmit = useCallback(async () => {
    if (!activeTemplate) return;
    const { id } = activeTemplate;
    try {
      await deleteTemplate({ id }).unwrap();
      close();
    } catch (error) {
      // Код 15 — повтор: первый запрос шаблон уже удалил. Кэш приводится к тому, что дал бы успех, —
      // шаблон уходит из списка, окно закрывается (раньше оно висело над удалённым).
      if (isDuplicateRequest(error)) {
        dispatch(removeBoardTemplateFromCache(id));
        close();
        return;
      }
      toastApiError(error, msg`Не удалось удалить шаблон`);
    }
  }, [activeTemplate, close, deleteTemplate, dispatch, toastApiError]);

  const entityName = activeTemplate?.name;

  return {
    modal: (
      <Modal.Confirm
        show={isOpen}
        title={entityName ? t`Удалить шаблон «${entityName}»?` : t`Удалить шаблон?`}
        description={t`Это действие необратимо.`}
        onConfirm={onSubmit}
        onCancel={close}
      />
    ),
    close,
    open,
  };
}

export default useDeleteModal;
